import styled from 'styled-components';

import { INPUT_BORDER_WIDTH } from '@wecasa/common/src/components/input/styles';
import colors from '@wecasa/common/src/utils/colors';

import Text from '../../base-text/variants/text';

export const MessageContainer = styled.div`
  margin-top: 3px;
  margin-left: ${INPUT_BORDER_WIDTH}px;
`;

type BottomMessageProps = {
  error?: string;
  message?: string;
};

const BottomMessage = ({ error, message }: BottomMessageProps) => {
  if (error) {
    return (
      <MessageContainer>
        <Text.XS color={colors.error100}>{error}</Text.XS>
      </MessageContainer>
    );
  }
  if (message) {
    return (
      <MessageContainer>
        <Text.SM color={colors.ink50}>{message}</Text.SM>
      </MessageContainer>
    );
  }

  return null;
};

export default BottomMessage;
